export default __webpack_public_path__ + "static/media/fl-logo.ee828505.png";